{
  "available_dates": "Beschikbare data",
  "booking_information": "Boekingbevestiging",
  "choose_your_ship_one": "Schip",
  "choose_your_ship_other": "Kies uw schip",
  "date": "Datum",
  "explanation": "",
  "title": "Prijzen & beschikbaarheid",
  "x_th_cabin": "{{ index }}. {{ name }}"
}
